import React from 'react'
import './Home.css'
import ProfileImg from './Ankitchoubey.jpg'

function Home() {
  return (
    <div>
      <div className='home-container'>
        <div className='info-container'>
          <h2>Welcome</h2>
          <h1>I am web designer</h1>
          <p>Hey everyone welcome to my portfolio i am here to introduced <br />
            myself and my journey please move ahead and read my interesting journey.
          </p>
        </div>
        <div className='profile-pciture'>
          <img src={ProfileImg}></img>
        </div>
      </div>
      <div className='language-container'>
        <h2>This is what is learn during the college holiday language.</h2>
        <div className='firstContainer' style={{ display: 'flex', justifyContent: 'space-between',flexWrap:'wrap' }}>
          <div className='box'>
            <div className='content'>
              <h2>c</h2>
              <h3>90%</h3>
            </div>
          </div>
          <div className='box'>
            <div className='content'>
              <h2>c++</h2>
              <h3>90%</h3>
            </div>
          </div>
          <div className='box'>
            <div className='content'>
              <h2>Python</h2>
              <h3>90%</h3>
            </div>
          </div>
          <div className='box'>
            <div className='content'>
              <h2>Javascript</h2>
              <h3>90%</h3>
            </div>
          </div>
        </div>
        <div className='secondContainer' style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0',flexWrap:'wrap'}}>
          <div className='box'>
            <div className='content'>
              <h2>Java</h2>
              <h3>90%</h3>
            </div>
          </div>
          <div className='box'>
            <div className='content'>
              <h2>c sharp</h2>
              <h3>90%</h3>
            </div>
          </div>
          <div className='box'>
            <div className='content'>
              <h2>css</h2>
              <h3>90%</h3>
            </div>
          </div>
          <div className='box'>
            <div className='content'>
              <h2>ReactJs</h2>
              <h3>90%</h3>
            </div>
          </div>
        </div>

      </div>

    </div>
  )
}

export default Home
